<template>
	<div>
		<transition name="modal">
			<div class="modal"
			     style="display: block">
				<div class="modal-dialog"
				     role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h4 class="modal-title"
							    id="exampleModalLabel">
								<span v-if="!userData.check_link_service">{{$t('dashboard.check_link_enable')}}</span>
								<span v-else>{{$t('dashboard.check_link_disable')}}</span>
								{{$t('dashboard.check_link_modal_title')}}
							</h4>

							<button type="button"
							        class="close"
											style="outline:none"
							        @click="closeModal()">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
              <p style="font-style:italic">{{$t('dashboard.check_link_modal_subtitle')}}</p>
							{{$t('dashboard.check_link_modal_description')}}
              <p class="mt-4" v-html="$t('dashboard.check_link_modal_alert')"> </p>
						</div>
						<div class="modal-footer">
							<button type="button"
							        class="btn btn-success abtg__default-button abtg__btn-default"
							        @click="closeModal()">
								{{$t('dashboard.check_link_modal_cancel')}}
							</button>
							<button type="button"
								style="border: 1px solid transparent;"
							        class="btn btn-success abtg__default-button abtg__btn-star"
							        @click="triggerCheckLink()"
							        data-dismiss="modal">
								<span v-if="!userData.check_link_service">{{$t('dashboard.check_link_enable')}}</span>
								<span v-else>{{$t('dashboard.check_link_disable')}}</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'

	export default {
		props: [''],
		components: {},
		data: function() {
			return {}
		},
		computed: {
			...mapState('n_user', ['userData']),
		},
		created: function() {},
		methods: {
			...mapActions('n_user', ['activateDeactivateLinkCheck']),

			triggerCheckLink: function() {
				this.activateDeactivateLinkCheck()
				this.closeModal()
			},

			closeModal: function() {
				this.$emit('closeModal')
			},
		},
	}
</script>
